import { contentBlockSurface, index, Options } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  position: sticky;
  width: 100%;
  min-width: 0;
  top: 0;

  z-index: ${index(Options.TOPBAR)};
  ${contentBlockSurface};
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  margin-left: ${({ theme }) => `-${theme.spacing(2)}`};
`;

export const LeadingContainer = styled.div`
  flex: 1;
  min-width: 0;

  display: flex;
  align-items: center;
`;

export const Divider = styled.div`
  flex-shrink: 0;
  width: 1px;
  height: 1.6rem;
  align-self: center;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  flex: 1;
  min-width: 0;
  overflow: hidden;

  color: ${({ theme }) => theme.palette.text.primary};

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const NavigationContainer = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing(6)}`};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const InteractionsContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;

  ${({ theme }) =>
    theme.isMobile &&
    css`
      flex: initial;
    `};
`;

export const Interactions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  position: relative;

  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const FavoriteButtonContainer = styled.div`
  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;
